export default "__VITE_ASSET__BblUKxax__"